import { useContext, useRef } from "react";
import { Link } from "react-router-dom";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import useI18n from "../../../hooks/useTranslations";
import { ListItemWithQuantity } from "../../../http/types/items";
import { useItemsApi } from "../../../http/useItems";
import SvgExcel from "../../icons/Excel";
import Button from "../../ui/Button";
import FlexContent from "../../ui/FlexContent";
import SubmitBar from "../../ui/SubmitBar";
import Table from "../../ui/Table";
import styles from "./BorderCalculationPanel.module.css";

type BorderCalculationPanelProps = {
  configurationId: string;
  disabled?: boolean;
  isAdmin?: boolean;
  back: () => void;
};

const BorderCalculationPanel = ({ configurationId, disabled, isAdmin, back }: BorderCalculationPanelProps) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const itemsApi = useItemsApi();
  const { data, error } = itemsApi.getConfigurationItemsList(configurationId, aborter.current.signal);

  return (
    <FlexContent padding direction="row">
      <div className={styles.form}>
        <Table<ListItemWithQuantity>
          head={
            <tr>
              <th align="left">{i18n.translation.common.code}</th>
              <th align="left">{i18n.translation.common.description}</th>
              <th align="right">{i18n.translation.common.qty}</th>
              <th align="right">{i18n.translation.common.minOrderQuantity}</th>
            </tr>
          }
          items={data}
          renderRow={(item) => (
            <>
              <td>
                <Link to={`${isAdmin ? "/admin" : ""}/items/${item.id}`}>{item.code}</Link>
              </td>
              <td>{item.description}</td>
              <td align="right">{item.quantity}</td>
              <td align="right">{item.minOrderQuantity}</td>
            </>
          )}
          error={!!error}
        />
        <SubmitBar>
          <Button
            buttonProps={{
              disabled: disabled || !data || !!error,
              onClick: back,
            }}
            type="secondary"
          >
            {i18n.translation.common.back}
          </Button>
          <Button
            glyph={SvgExcel}
            buttonProps={{
              disabled: disabled || !data || !!error,
              onClick: () =>
                itemsApi
                  .downloadEServiceExportConfigurationItemsList(configurationId)
                  .catch((err) => dispatch(showErrorNotification(i18n, err))),
            }}
          >
            {i18n.translation.common.excel}
          </Button>
        </SubmitBar>
      </div>
    </FlexContent>
  );
};

export default BorderCalculationPanel;
